/**
 * Jotai atoms for discount details drawer state management
 *
 * The drawer state is URL-driven:
 * - URL format: /:servicesProviderId/discounts/:tabId/:discountId/:detailsTab
 * - When discountId and detailsTab params are present, drawer is open
 * - When discountId and detailsTab params are absent, drawer is closed
 *
 * Use the `useDiscountNavigation` hook for all navigation operations.
 */

import { atom } from 'jotai';

import type { DiscountsTableRow } from '@ekhodealer/ekho-common';

export enum DiscountDetailsTab {
	OVERVIEW = 'overview',
}

// Sentinel value used as the discountId URL param when creating a new discount
export const NEW_DISCOUNT_ID = 'new';

// ============================================================================
// Selected Discount State
// Stores the currently selected discount for child components to access
// This is set by the DiscountDetailsDrawer based on the URL params
// ============================================================================

export interface DiscountDetailsDrawerState {
	selectedRow: DiscountsTableRow | null;
}

export const discountDetailsDrawerAtom = atom<DiscountDetailsDrawerState>({
	selectedRow: null,
});

// ============================================================================
// Drawer Mode
// Controls whether the drawer is in view, create, or duplicate mode
// ============================================================================

export const discountDrawerModeAtom = atom<'view' | 'create' | 'duplicate'>('view');

// ============================================================================
// Form Dirty State
// Controls Cancel/Save button visibility in the drawer footer
// ============================================================================

export const discountFormDirtyAtom = atom<boolean>(false);
